import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter = () => {
  return (
    <footer id="footer">
      
      <nav>
        <ul id="sitemap">
          {/* <li> <Link onClick={window.scrollTo(0,0)} to="/">Főoldal</Link> </li> */}
          <li> <Link to="/kozerdeku">Közérdekű adatok</Link> </li>
          <li> <Link to="/tevekenysegek">Tevékenységek</Link> </li>
          <li> <Link to="/rolunk">Rólunk</Link> </li>
          <li> <Link to="/kapcsolat">Kapcsolat</Link> </li>
        </ul>
      </nav>

      <div id="info">

        <div id="info-address">
          <h3>Elérhetőség</h3>
          <address>5310 Kisújszállás<br/>Kossuth L. U. 74.</address>
        </div>

        <div id="info-contact">
          <h3>Kapcsolat</h3>
          <ul id="info-contact-list">

            <li>
              <a href="mailto: varosgazdalkodas@kjvgkft.hu"><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg> varosgazdalkodas@kjvgkft.hu</a>
            </li>

            <li>
              <a href="tel: +36-59-520-210"><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg> Tel: 59/520-210</a>
            </li>

            <li>
              <p><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg> Fax: 59/520-219</p>
            </li>

          </ul>
          
        </div>

      </div>

    </footer>
  );
};

export default AppFooter;